export default __webpack_public_path__ + "static/media/Poster Exhibition.f96ef90a.JPG";